import actions from '../../constants/actionTypes';

const initialState = {
  metadata: null,
  userProfile: null,
  currentRestaurant: null,
};

function nowShipGeneralReducer(state = initialState, action) {
  const { response, type } = action;
  switch (type) {
    case actions.RECEIVE_INIT_DATA_NOW_SHIP: {
      return {
        ...state,
        ...response,
      };
    }
    case actions.CHANGE_CURRENT_RESTAURANT_NOW_SHIP: {
      const { restaurant } = response;
      return {
        ...state,
        currentRestaurant: restaurant,
      };
    }
    default: {
      return state;
    }
  }
}

export default nowShipGeneralReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/NowShip/reducers.js